import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Heart, Shield, CheckCircle2, Clock, Gift } from 'lucide-react';
import { toast } from 'sonner';

const SplashScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-5" data-testid="splash-screen">
      <div className="max-w-lg w-full text-center space-y-8 fade-in">
        <div className="flex justify-center">
          <div className="relative w-24 h-24 flex items-center justify-center">
            <div className="absolute inset-0 rounded-full border-2 border-cyan-300/40 animate-pulse" />
            <div className="absolute inset-3 rounded-full border-2 border-cyan-400/60" />
            <div className="absolute inset-6 rounded-full border-2 border-cyan-500/80" />
            <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center shadow-lg">
              <Heart className="w-5 h-5 text-white" fill="currentColor" />
            </div>
          </div>
        </div>

        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground leading-tight tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
            CircleUp<span className="text-cyan-600">Squad</span><sup className="text-[8px] text-muted-foreground align-super ml-0.5">™</sup>
          </h1>
          <p className="text-base text-muted-foreground mt-3 max-w-sm mx-auto leading-relaxed">
            By an adult with <span className="text-lg font-bold text-foreground">cancer</span> for adults with <span className="text-lg font-bold text-foreground">cancer</span> who want their care to be:
          </p>
        </div>

        <div className="space-y-3 text-left max-w-xs mx-auto">
          {[
            { icon: Shield, text: 'Private: Only a chosen group has access to private info' },
            { icon: CheckCircle2, text: 'Immediate: Needs are current and able to be delegated' },
            { icon: Heart, text: 'Patient-Centered: No more random advice or weird casseroles' },
            { icon: Clock, text: 'Short term: Cancer treatment lasts about a year. Once it\'s over, delete this app!' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-3 py-2">
              <div className="w-9 h-9 bg-primary/10 dark:bg-primary/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <item.icon className="w-4 h-4 text-cyan-600" />
              </div>
              <p className="text-sm text-muted-foreground">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="space-y-3 pt-2 max-w-xs mx-auto">
          <Button
            data-testid="patient-btn"
            size="lg"
            className="btn-primary text-base w-full h-12"
            onClick={() => navigate('/patient-onboarding')}
          >
            I'm the patient
          </Button>
          <Button
            data-testid="invited-btn"
            size="lg"
            variant="outline"
            className="text-base w-full h-12 border-cyan-300 text-cyan-700 hover:bg-cyan-50 dark:border-cyan-700 dark:text-cyan-300 dark:hover:bg-cyan-900/20"
            onClick={() => {
              toast.info('Check your email for an invitation link. If you haven\'t received one yet, ask your patient to send you an invite from within the app.');
            }}
          >
            I've been invited by a patient
          </Button>
          <p className="text-sm text-muted-foreground text-center">
            Already have an account?{' '}
            <button onClick={() => navigate('/auth')} className="text-cyan-600 hover:text-cyan-700 font-semibold transition-colors">
              Sign In
            </button>
          </p>
          <button
            onClick={() => navigate('/gift')}
            className="flex items-center justify-center gap-2 text-sm text-cyan-600 hover:text-cyan-700 font-medium transition-colors mt-2 mx-auto"
            data-testid="gift-btn"
          >
            <Gift className="w-4 h-4" />
            Want to give the gift of CircleUpSquad?
          </button>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
